<template>
<div>


    
    <div class="relative z-8 pt-6 pb-16 sm:pb-24">
      <div class="max-w-7xl mx-auto px-4 sm:px-6">
        <nav class="relative flex items-center justify-between sm:h-10 md:justify-center" aria-label="Global">
          <div class="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0">
            <div class="flex items-center justify-between w-full md:w-auto">
              <a @click="goHome()">
                <span class="sr-only">Menu</span>
                <img class="h-auto w-12 sm:h-10" src="https://homemanagerfortesting.s3.amazonaws.com/vqv.png" alt="">
              </a>
              <div class="-mr-2 flex items-center md:hidden">
                <button type="button" class="bg-gray-50 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" id="main-menu" aria-haspopup="true">
                  <span class="sr-only">Menu</span>
                  <!-- Heroicon name: menu -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div class="hidden md:absolute md:flex md:items-center md:justify-end md:inset-y-0 md:right-0">

              <!-- This example requires Tailwind CSS v2.0+ -->
              <div v-if="$store.state.auth" @mouseover="isOpenMenu = true" @mouseleave="isOpenMenu = false" class="relative inline-block text-left">
                <div>
                  <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" id="options-menu" aria-haspopup="true" aria-expanded="true">
                    <small class="mr-2">Welcome</small> {{ $store.state.user.name }}
                    <!-- Heroicon name: chevron-down -->
                    <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </button>
                </div>
                <div class="absolute w-full text-white" style="">.</div>
                <div v-show="isOpenMenu" class="z-30 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                  <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                    <a href="#" v-if="$store.state.user.roles != ''" @click="goAccount()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">Account settings</a>
                    <a href="#" @click="goProfile()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">Profile</a>
                    <a href="#" @click="goSub()" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">Subscription</a>
                      <a @click="logout()" class="relative block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        Sign out
                      </a>

                  </div>
                </div>
              </div>
              <div v-else>
                  <a @click="goLogin()" href="#" class="whitespace-nowrap bg-cyan-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex items-center justify-center text-base font-medium text-white hover:bg-cyan-700">
                    Sign in
                  </a>
              </div>


            </div>
        </nav>
      </div>


      <div class="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
        <div class="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div class="px-5 pt-4 flex items-center justify-between">
            <div>
              <img class="h-8 w-auto" src="https://homemanagerfortesting.s3.amazonaws.com/vqv.png" alt="">
            </div>
            <div class="-mr-2">
              <button @click="isOpenMenu = !isOpenMenu" type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                <span class="sr-only">Close main menu</span>
                <!-- Heroicon name: x -->
                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <div v-show="isOpenMenu" role="menu" aria-orientation="vertical" aria-labelledby="main-menu">
            <div role="none">

              <template v-if="$store.state.auth" class="ml-4">
                <span class="nav-item nav-link"
                  ><small>Hi,</small>  {{ $store.state.user.name }} </span
                >
                <button class="nav-item nav-link" @click="logout">Logout</button>
              </template>

              <template class="ml-4" v-else>
                  <a href="#" @click="goLogin()" class="block w-full px-5 py-3 text-center font-medium text-indigo-600 bg-gray-50 hover:bg-gray-100 hover:text-indigo-700" role="menuitem">
                    Log in
                  </a>
              </template>

              
            </div>
          </div>
        </div>
      </div>


    </div>

    

</div>

</template>

<script>
export default {
  data() {
    return {
      isOpenMenu: false,
    };
  },

  methods: {

    goSub() {
      this.$router.push({ name: "subscription" },);
    },

    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Home" });
    },

    goServices() {


    },

    goLogin() {
       this.$router.push({ name: "Login" },);

    },

    goAccount() {
       this.$router.push({ name: "MyAccount" },);

    },

    goProfile() {
      this.$router.push({ name: "myProfile" },);
    },

    goHome() {
      this.$router.push({ name: "Home" },);
    },

    goAbout() {
      this.$router.push({ name: "About" },);
    },

    goStarted(){
      this.$router.push({ name: "Start" },);
    },

    goPortfolio(){
      this.$router.push({ name: "Portfolio" })
    }

  }
};
</script>
